module.exports = __webpack_public_path__ + "static/media/calculator.0bb5415c.png";